import { Head, useForm } from '@inertiajs/react'
import AdminLayout from '../../components/layout/AdminLayout'
import Input from '../../components/ui/Input'
import Select from '../../components/ui/Select'
import Textarea from '../../components/ui/Textarea'
import Checkbox from '../../components/ui/Checkbox'

export default function PropertiesNew({ propertyTypes, transactionTypes }) {
  const { data, setData, post, processing, errors } = useForm({
    property_type: 'apartment',
    transaction_type: 'sale',
    status: 'available',
    title: '',
    description: '',
    address: '',
    city: '',
    zip_code: '',
    price: '',
    surface: '',
    rooms: '',
    bedrooms: '',
    floor: '',
    elevator: false,
    balcony: false,
    parking: false,
    garden: false,
    available_for_network: true
  })

  const handleSubmit = (e) => {
    e.preventDefault()
    post('/properties')
  }

  return (
    <AdminLayout>
      <Head title="Nouvelle propri&eacute;t&eacute;" />

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-gray-900">Nouvelle propri&eacute;t&eacute;</h1>
          <p className="mt-2 text-sm text-gray-600">
            Cr&eacute;ez une nouvelle propri&eacute;t&eacute; pour votre catalogue
          </p>
        </div>

        <form onSubmit={handleSubmit} className="bg-white shadow-sm rounded-lg p-6 space-y-6">
          {/* Type et Transaction */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <Select
              label="Type de bien"
              name="property_type"
              value={data.property_type}
              onChange={(e) => setData('property_type', e.target.value)}
              error={errors.property_type}
              required
              options={propertyTypes.map((type) => ({
                value: type,
                label: translatePropertyType(type)
              }))}
            />

            <Select
              label="Type de transaction"
              name="transaction_type"
              value={data.transaction_type}
              onChange={(e) => setData('transaction_type', e.target.value)}
              error={errors.transaction_type}
              required
              options={transactionTypes.map((type) => ({
                value: type,
                label: translateTransactionType(type)
              }))}
            />
          </div>

          {/* Titre */}
          <Input
            label="Titre"
            name="title"
            value={data.title}
            onChange={(e) => setData('title', e.target.value)}
            error={errors.title}
            placeholder="Ex: Appartement T3 avec balcon"
            required
          />

          {/* Description */}
          <Textarea
            label="Description"
            name="description"
            value={data.description}
            onChange={(e) => setData('description', e.target.value)}
            error={errors.description}
            rows={4}
            placeholder="D&eacute;crivez la propri&eacute;t&eacute;..."
          />

          {/* Adresse */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="md:col-span-2">
              <Input
                label="Adresse"
                name="address"
                value={data.address}
                onChange={(e) => setData('address', e.target.value)}
                error={errors.address}
                placeholder="12 rue de la Paix"
                required
              />
            </div>

            <Input
              label="Code postal"
              name="zip_code"
              value={data.zip_code}
              onChange={(e) => setData('zip_code', e.target.value)}
              error={errors.zip_code}
              placeholder="75001"
              required
            />
          </div>

          <Input
            label="Ville"
            name="city"
            value={data.city}
            onChange={(e) => setData('city', e.target.value)}
            error={errors.city}
            placeholder="Paris"
            required
          />

          {/* Prix et caract&eacute;ristiques */}
          <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
            <Input
              label="Prix (&euro;)"
              type="number"
              name="price"
              value={data.price}
              onChange={(e) => setData('price', e.target.value)}
              error={errors.price}
              placeholder="250000"
              required
            />

            <Input
              label="Surface (m&sup2;)"
              type="number"
              name="surface"
              value={data.surface}
              onChange={(e) => setData('surface', e.target.value)}
              error={errors.surface}
              placeholder="75"
            />

            <Input
              label="Pi&egrave;ces"
              type="number"
              name="rooms"
              value={data.rooms}
              onChange={(e) => setData('rooms', e.target.value)}
              error={errors.rooms}
              placeholder="3"
            />

            <Input
              label="Chambres"
              type="number"
              name="bedrooms"
              value={data.bedrooms}
              onChange={(e) => setData('bedrooms', e.target.value)}
              error={errors.bedrooms}
              placeholder="2"
            />
          </div>

          {/* &Eacute;tage */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <Input
              label="&Eacute;tage"
              type="number"
              name="floor"
              value={data.floor}
              onChange={(e) => setData('floor', e.target.value)}
              error={errors.floor}
              placeholder="2"
            />
          </div>

          {/* &Eacute;quipements */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-3">
              &Eacute;quipements
            </label>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
              <Checkbox
                label="Ascenseur"
                name="elevator"
                checked={data.elevator}
                onChange={(e) => setData('elevator', e.target.checked)}
              />

              <Checkbox
                label="Balcon"
                name="balcony"
                checked={data.balcony}
                onChange={(e) => setData('balcony', e.target.checked)}
              />

              <Checkbox
                label="Parking"
                name="parking"
                checked={data.parking}
                onChange={(e) => setData('parking', e.target.checked)}
              />

              <Checkbox
                label="Jardin"
                name="garden"
                checked={data.garden}
                onChange={(e) => setData('garden', e.target.checked)}
              />
            </div>
          </div>

          {/* Disponible pour le r&eacute;seau */}
          <Checkbox
            label="Disponible pour le r&eacute;seau d'agences partenaires"
            name="available_for_network"
            checked={data.available_for_network}
            onChange={(e) => setData('available_for_network', e.target.checked)}
          />

          {/* Boutons */}
          <div className="flex gap-4 pt-4 border-t">
            <button
              type="submit"
              disabled={processing}
              className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50 transition-colors"
            >
              {processing ? 'Cr&eacute;ation...' : 'Cr&eacute;er la propri&eacute;t&eacute;'}
            </button>

            <a
              href="/properties"
              className="px-6 py-2 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 transition-colors"
            >
              Annuler
            </a>
          </div>
        </form>
      </div>
    </AdminLayout>
  )
}

function translatePropertyType(type) {
  const translations = {
    'apartment': 'Appartement',
    'house': 'Maison',
    'land': 'Terrain',
    'commercial': 'Commercial',
    'parking': 'Parking'
  }
  return translations[type] || type
}

function translateTransactionType(type) {
  const translations = {
    'sale': 'Vente',
    'rental': 'Location'
  }
  return translations[type] || type
}
